import React, {Component} from 'react';
import VIDABOO_CONSTANTS from '../../config/consts';
import {ListeningRoomService} from '../../services/websocketService';
import {AppContext} from '../../AppModule/Context';

import ThreedWrapper from './threedWrapper';

class ThreedClientContainerComponent extends Component {
  state = {selected3DFile: ''};
  componentDidMount = () => {
    this.registerLRListener();
  };
  componentWillUnmount = () => {
    this.deleteDoWhenMessageReceivedFromListeningRoom &&
      this.deleteDoWhenMessageReceivedFromListeningRoom();
  };
  registerLRListener = () => {
    this.deleteDoWhenMessageReceivedFromListeningRoom =
      ListeningRoomService.doWhenMessageReceivedFromListeningRoom((data) => {
        if (
          data.messageType === VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.THREED
        ) {
          var subType = data.content.SubType;
          if (
            subType === VIDABOO_CONSTANTS.THREED_SUBTYPES.OPEN_THREED_REQUEST
          ) {
            if (
              this.context.otVideoContainerSize ===
              VIDABOO_CONSTANTS.ACTIVE_3D_SIZE.FULL_SCREEN
            ) {
              this.context.setThreedContainerSize(
                VIDABOO_CONSTANTS.ACTIVE_3D_SIZE.FULL_SCREEN,
              );
            }
            if (
              this.context.callState === VIDABOO_CONSTANTS.VIDEO_CALL_STATE.INIT
            )
              this.props.changeIframeSize &&
                this.props.changeIframeSize(
                  VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_OPEN,
                  'threed',
                  'visible',
                );
            this.setState({
              threedOn: true,
              selected3DFile: data.content.message.selected3DFile,
            });
          } else if (
            subType === VIDABOO_CONSTANTS.THREED_SUBTYPES.CLOSE_THREED_REQUEST
          ) {
            this.setState({
              threedOn: false,
            });
          }
        }
      });
  };

  closeThreed = () => {
    this.setState({threedOn: false});
  };
  render() {
    return this.state.threedOn ? (
      <ThreedWrapper
        present3D={true}
        client={true}
        cancelPresent3d={this.closeThreed}
        isMentor={false} // this is the client side.
        peerUserId={this.props.extendedMentorDto.mentorDto.mentorOwnerId}
        closeThreed={this.closeThreed}
        selected3DFile={this.state.selected3DFile}
        fileSettings={false}
        changeIframeSize={this.props.changeIframeSize}
      />
    ) : null;
  }
}
ThreedClientContainerComponent.contextType = AppContext;

export default ThreedClientContainerComponent;
